import { RouteAuthenticationRequirement, RouteItem } from '@cksoftware/react-base';
import { ApplicationRoutes } from '../constants/appRoutes';
import { ClientLayout } from '../components/layout/clientLayout';
import {
  faChartBar,
  faCloudDownloadAlt,
  faGavel,
  faHome,
  faInfoCircle,
  faStoreAlt,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { Layout } from '../components/layout/layout.tsx';

export const AboutUsRouteItem: RouteItem = {
  path: ApplicationRoutes.client.aboutUs,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  text: 'About Us',
  layout: <ClientLayout />,
  icon: faInfoCircle,
  async lazy() {
    const component = await import('../features/aboutUs/AboutUsPage');
    return { Component: component.AboutUsPage };
  }
};

export const HomeRouteItem: RouteItem = {
  path: ApplicationRoutes.client.home,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  text: 'Home',
  icon: faHome,
  layout: <ClientLayout />
};

export const ContactUsRouteItem: RouteItem = {
  path: ApplicationRoutes.client.contactUs,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  text: 'Contact Us',
  icon: faUser,
  layout: <ClientLayout />,
  async lazy() {
    const component = await import('../features/contactUs/ContactUsPage');
    return { Component: component.ContactUsPage };
  }
};

export const ListingMarketsRouteItem: RouteItem = {
  path: ApplicationRoutes.client.listingMarkets,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  text: 'Listing Markets',
  icon: faStoreAlt,
  layout: <ClientLayout />,
  async lazy() {
    const component = await import('../features/listingMarkets/ListingMarketsPage');
    return { Component: component.ListingMarketsPage };
  }
};

export const MarketReportsRouteItem: RouteItem = {
  path: ApplicationRoutes.client.marketReports,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [],
  text: 'Market Reports',
  icon: faChartBar,
  layout: <ClientLayout />,
  async lazy() {
    const component = await import('../features/marketReports/MarketReportsPage');
    return { Component: component.MarketReportsPage };
  }
};

export const MarketReportDetailRouteItem: RouteItem = {
  path: ApplicationRoutes.client.marketReportDetail,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  disableDefaultNavItem: true,
  text: 'Market Report Detail',
  layout: <ClientLayout />,
  async lazy() {
    const component = await import('../features/marketReports/MarketReportDetailsPage.tsx');
    return { Component: component.MarketReportDetailsPage };
  }
};

export const SupportAndDemoRouteItem: RouteItem = {
  path: ApplicationRoutes.client.supportAndDemo,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  text: 'Support / Demo',
  icon: faCloudDownloadAlt,
  layout: <ClientLayout />,
  async lazy() {
    const component = await import('../features/supportAndDemo/SupportAndDemoPage.tsx');
    return { Component: component.SupportAndDemoPage };
  }
};

export const BuyerApprovalRouteItem: RouteItem = {
  path: ApplicationRoutes.client.buyerApproval,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [],
  text: 'Buyer Approval',
  icon: faGavel,
  textStyle: {
    color: 'green.500',
    fontWeight: 'bold'
  },
  layout: <ClientLayout />,
  async lazy() {
    const component = await import('../features/buyerApproval/client/BuyerApprovalClient.tsx');
    return { Component: component.BuyerApprovalClient };
  }
};

export const AuctionReportRouteItem: RouteItem = {
  path: ApplicationRoutes.report.auctionLots,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  disableDefaultNavItem: true,
  text: 'Auction Information',
  layout: <ClientLayout />,
  async lazy() {
    const component = await import('../features/auctionReport/AuctionReportPage');
    return { Component: component.AuctionReportPage };
  }
};

export const AuctionLotReportRouteItem: RouteItem = {
  path: ApplicationRoutes.report.auctionLotDetails,
  authenticationRequirement: RouteAuthenticationRequirement.Either,
  disableDefaultNavItem: true,
  text: 'Auction Lot Information',
  layout: <ClientLayout />,
  async lazy() {
    const component = await import('../features/auctionReport/components/lotReport/LotReportPage');
    return { Component: component.LotReportPage };
  }
};

export const TermsOfServiceRouteItem: RouteItem = {
  path: ApplicationRoutes.client.termsOfService,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/termsOfService/TermsOfServicePage.tsx');
    return { Component: component.TermsOfServicePage };
  }
};
